module.exports = __webpack_public_path__ + "img/cf78480.png";